export default "__VITE_ASSET__8ffbd5ad__"